module.exports = __webpack_public_path__ + "img/20190726161249461.587792b1.png";